import VueRouter from 'vue-router';
import ChatWindow from './components/chat-window';
import WebTabDetail from './components/web-tab-detail/index';

const routes = [
    {
        name: 'ChatWindow',
        path: '/',
        component: ChatWindow,
    },
    {
        name: 'WebTabDetail',
        path: '/web-tab-detail/:channelType/:isDefaultTpl/:tplId',
        component: WebTabDetail,
        props: route => ({
            isDefaultTpl: Boolean(Number(route.params.isDefaultTpl)),
            tplId: Number(route.params.tplId),
            channelType: Number(route.params.channelType),
        }),
    },
];

export default new VueRouter({
    routes,
});
